<template>
  <div class="areaMonitorReport">
    <!-- 导航栏 -->
    <nav-header id="m-header" :head-title="navTitle"></nav-header>
    <!-- 搜索框 -->
    <form action="/">
      <van-search
        v-model="keyword"
        placeholder="按名称搜索医疗机构"
        shape="round"
        clearable
        @search="handleSearch"
      />
    </form>
    <div class="m-holder"></div>
    <!-- tab -->
    <van-tabs
      color="#1C91FF"
      title-inactive-color="#666666"
      title-active-color="#1C91FF"
      v-model="activeType"
      swipeable
      @change="handTabChange"
    >
      <van-tab :title="`已上报(${reptCount})`">
        <van-pull-refresh v-model="hadRefreshing" @refresh="onRefresh">
          <van-list
            v-model="hadLoading"
            :finished="hadFinished"
            :finished-text="compeletedList.length > 0 ? '没有更多了' : ''"
            @load="onLoad"
            :immediate-check="false"
          >
            <div class="container">
              <!-- 列表 -->
              <div
                class="report-list"
                v-if="compeletedList.length > 0 || hadFinished == false"
              >
                <div
                  class="report-item df-between"
                  v-for="(item, index) in compeletedList"
                  :key="index"
                  @click="jumpTo(item)"
                >
                  <div class="left">
                    <div class="left-top">{{ item.comName }}</div>
                    <div class="left-bottom">
                      上报时间：{{ item.modTime }}
                    </div>
                  </div>
                  <img
                    src="../../assets/images/monitorRecord/i-arrow-right.png"
                    alt=""
                    class="right"
                  />
                </div>
              </div>
              <!-- 空数据  -->
              <empty-component v-else></empty-component>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab>
        <template #title>未上报({{noReptCount}})<van-icon @click='handleTips' name="question-o" /> </template>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="unCompeletedList.length > 0 ? '没有更多了' : ''"
            @load="onLoad"
            :immediate-check="false"
          >
            <div class="container">
              <!-- 列表 -->
              <div
                class="report-list-uncompeted"
                v-if="unCompeletedList.length > 0 || finished == false"
              >
                <div
                  class="report-item df-between"
                  v-for="(item, index) in unCompeletedList"
                  :key="index"
                >
                  <div class="left">{{ item.comName }}</div>
                  <div
                    class="right"
                    :class="{
                      'right-complete': item.finishCount == item.totalCnt,
                    }"
                  >
                    <div class="process">
                      已完成{{ item.finishCount }}/{{ item.totalCnt }}
                    </div>
                  </div>
                </div>
                <div class="pop-tip" v-if="popTipFlag && activeType == 1">
                  <div class="inner-pop-tip">
                    上报总共分为“准备工作”、“手卫生依从监测”和“其他数据监测”3个环节，已完成数字代表了医院完成的进度
                  </div>
                  <img
                    src="../../assets/images/monitorRecord/i-close-btn.png"
                    alt=""
                    class="close-btn"
                    @click="closeBtn"
                  />
                </div>
              </div>
              <!-- 空数据  -->
              <empty-component v-else></empty-component>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>

    <!-- <div class="search-box">
      <input type="text" placeholder="按名称搜索医疗机构" />
    </div> -->
  </div>
</template>

<script>
import navHeader from "../../components/header/fixed-header.vue";
import emptyComponent from "../../components/empty-component/empty-component.vue";
import Vue from "vue";
import { mapState } from "vuex";
import { Search, Swipe, SwipeItem } from "vant";

Vue.use(Search);
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      pageInfo: {
        page: 1,
        rows: 12,
      },
      hadLoading: false,
      hadFinished: false,
      hadRefreshing: false,
      hadPageInfo: {
        page: 1,
        rows: 12,
      },
      navTitle: "",
      keyword: "",
      activeType: "",
      popTipFlag: false,
      compeletedList: [],
      unCompeletedList: [],
      reptCount: 0,
      noReptCount: 0,
    };
  },
  components: {
    navHeader,
    emptyComponent,
  },
  computed: {
    ...mapState({
      _userInfo: (state) => state.InvestorInfo,
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.popTipFlag = from.path === "/" || from.path === "/";
    });
  },
  created() {
    document.title = this.$route.query.areaName
      ? this.$route.query.areaName
      : "湖南省";
    this.navTitle = document.title;
    this.getComFinishCountList();
    if (this.$route.query.reportCnt) {
      this.reptCount = this.$route.query.reportCnt;
    }
    if (this.$route.query.notReportCnt) {
      this.noReptCount = this.$route.query.notReportCnt;
    }
  },
  mounted() {},
  methods: {
    handleTips(){
      this.$toast("“未上报”指参与本次监测但还未上报的单位");
    },
    onLoad() {
      // 未上报
      if (this.activeType == 1) {
        if (this.refreshing) {
          // 刷新
          this.pageInfo.page = 1;
          this.finished = false;
          this.getComFinishCountList(this.activeType == 0 ? 1 : 0);
        } else {
          // 加载
          this.pageInfo.page++;
          this.getComFinishCountList(this.activeType == 0 ? 1 : 0);
        }
      } else if (this.activeType == 0) {
        if (this.hadRefreshing) {
          // 刷新
          this.hadPageInfo.page = 1;
          this.hadFinished = false;
          this.getComFinishCountList(this.activeType == 0 ? 1 : 0);
        } else {
          // 加载
          this.hadPageInfo.page++;
          this.getComFinishCountList(this.activeType == 0 ? 1 : 0);
        }
      }
    },
    onRefresh() {
      this.pageInfo.page = 1;
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    // 搜索上报
    handleSearch() {
      this.pageInfo.page = 1;
      this.hadPageInfo.page = 1;
      this.getComFinishCountList(this.activeType == 0 ? 1 : 0);
      console.log(this.keyword, "7878");
    },
    // tab改变
    handTabChange() {
      this.resetData();
      this.getComFinishCountList(this.activeType == 0 ? 1 : 0);
    },
    // 重置数据
    resetData() {
      this.loading = false;
      this.finished = false;
      this.refreshing = false;
      this.hadLoading = false;
      this.hadFinished = false;
      this.hadRefreshing = false;
      this.pageInfo.page = 1;
      this.hadPageInfo.page = 1;
      this.keyword = "";
    },
    // 获取已上报/未上报医院列表
    getComFinishCountList(reportState = "1") {
      let localPage = this.activeType == 0 ? this.hadPageInfo : this.pageInfo;
      let params2 = {
        comId: this._userInfo.data.comId,
        userId: this._userInfo.data.userId,
        data: {
          taskId: this.$route.query.taskId,
          batch: this.$route.query.batch,
          comName: this.keyword,
          reportState: reportState + "", // 1 已报 0 未报
          areaCode: this.$route.query.areaCode,
          page: localPage.page,
          rows: localPage.rows,
        },
      };
      this.$http.getComFinishCountList(params2).then((res) => {
        console.log(res);
        if (res.code == 0) {
          let resArr = res.data ? res.data : [];
          console.log(resArr, "56565");

          if (this.activeType === 0) {
            // 刷新
            if (this.hadRefreshing || this.hadPageInfo.page == 1) {
              this.compeletedList = [...resArr];
              this.hadRefreshing = false;
            } else {
              // 加载
              this.compeletedList = [...this.compeletedList, ...resArr];
            }
            setTimeout(() => {
              // 结束加载状态
              this.hadLoading = false;
              // 没有更多了
              if (resArr.length < 10) {
                this.hadFinished = true;
              }
            }, 100);
            // this.compeletedList = res.data ? res.data : [];
          } else {
            // 刷新
            if (this.refreshing || this.pageInfo.page == 1) {
              this.unCompeletedList = [...resArr];
              this.refreshing = false;
            } else {
              // 加载
              this.unCompeletedList = [...this.unCompeletedList, ...resArr];
            }
            setTimeout(() => {
              // 结束加载状态
              this.loading = false;
              // 没有更多了
              if (resArr.length < 10) {
                this.finished = true;
              }
            }, 100);
          }

          if (this.unCompeletedList && this.unCompeletedList.length > 0 &&  resArr.length == 0) {
            // this.$toast("没有更多数据");
          }
        } else {
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
          this.hadRefreshing = false;
          this.hadLoading = false;
          this.hadFinished = true;
          this.$toast(res.msg);
        }
      });
    },
    jumpTo(item) {

      // console.log(item,'4343');
      // return
      this.$router.push({
        path: "/areaReportDetail",
        query: {
          taskId: this.$route.query.taskId,
          comId: item.comId,
          comName: item.comName,
          batch: this.$route.query.batch,
          areaCode: this.$route.query.areaCode,
          keyword: this.keyword 
        },
      });
    },
    closeBtn() {
      this.popTipFlag = false;
    },
  },
};
</script>

<style lang='scss' scoped>
.areaMonitorReport {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
  min-height: 100vh;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  .search-box {
    box-sizing: border-box;
    padding: 16px 15px;
    background-color: #fff;
    input {
      width: 100%;
      height: 34px;
      background: #f7f8fa;
      border-radius: 18px;
      box-sizing: border-box;
      padding: 0 12px;
      font-size: 14px;
      color: #333;
    }
    ::placeholder {
      color: #666666;
      font-size: 14px;
    }
  }

  .m-holder {
    height: 11px;
  }

  .container {
    // flex: 1;
    // overflow: scroll;
  }

  .report-list {
    box-sizing: border-box;
    padding-top: 10px;
    // margin-bottom: 10px;
    .report-item {
      width: 100%;
      height: 85px;
      box-sizing: border-box;
      padding: 12px 15px 16px;
      background-color: #fff;
      border-bottom: 1px solid #eee;
      .left {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .left-top {
          font-size: 18px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          text-align: left;
          color: #333333;
          line-height: 25px;
        }
        .left-bottom {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #999999;
          line-height: 20px;
        }
      }
      .right {
        width: 18px;
        height: 18px;
      }
    }
  }

  .report-list-uncompeted {
    box-sizing: border-box;
    padding-top: 10px;
    position: relative;
    .report-item {
      box-sizing: border-box;
      padding: 20px 12px;
      height: 60px;
      opacity: 1;
      background: #ffffff;
      border-bottom: 1px solid #eee;
      .left {
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        color: #323233;
        line-height: 20px;
      }
      .right {
        flex-shrink: 0;
        font-size: 15px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #ff9d4a;
        line-height: 21px;
      }
      .right-complete {
        color: #666;
      }
    }
    .pop-tip {
      position: absolute;
      left: 63px;
      top: 51px;
      width: 306px;
      height: 140px;
      background: url("../../assets/images/monitorRecord/bg-dialog-msg.png");
      background-size: 100% 100%;
      .inner-pop-tip {
        position: absolute;
        top: 31px;
        left: 23px;
        width: 240px;
        height: 88px;
        opacity: 1;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        line-height: 22px;
      }
      .close-btn {
        position: absolute;
        top: 33px;
        right: 18px;
        width: 20px;
        height: 20px;
      }
    }
  }

  /deep/ .van-icon-search {
    color: #969799;
  }
  /deep/ .van-search__content {
    display: flex;
  }
  /deep/ .van-tabs__line {
    height: 2px;
  }
  /deep/ .van-tab__text {
    font-size: 16px;
  }
  /deep/ .van-tab__text--ellipsis{
    display: flex;
    align-items: center;
  }
}
</style>